import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-student-feedback',
  templateUrl: './student-feedback.component.html',
  styleUrls: ['./student-feedback.component.scss']
})
export class StudentFeedbackComponent implements OnInit {
  hidebutton: boolean=false;


 MeetingOptions:any;
  participantsptions: any;
   userForm: any = JSON.parse(localStorage.getItem('login_user_details'));
   stdID:any=this.userForm.id;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
   users: any = JSON.parse(localStorage.getItem('login_user_details'));
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  isButtonDisabled :boolean=false;
  CM_id: any;
  editmeetingform !:FormGroup;
  da_district:string;
  district: any = this.ApiService.user_details.district;
  constituency: any = this.ApiService.constituency;
  courses: any;
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;
  ob_data: any;
  mentor_data: any;
  enrolledCourses: any;
  CM_no_of_students: any;
  CM_students_attendance: any;
  CM_mentor: any;

  permanent_token:any=JSON.parse(localStorage.getItem('permanent_token'));


  onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onItemDeSelect(item: any) {
      console.log('onItemDeSelect', item);
  }
  onSelectAll(items: any) {
      console.log('onSelectAll', items);
  }
  onUnSelectAll() {
      console.log('onUnSelectAll fires');
  }


  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe) {
    this.createmeetingform= this.fb.group({
      course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date:['this.CM_startDate',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: ['', Validators.required],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
      status:['']
    });
    this.editformInitialize('false');
    this.district = JSON.parse(localStorage.getItem('user_district'));
    console.log('stdID: ', this.stdID);

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  ngOnInit():void{
    // this.ApiService.forstdId( this.stdID).subscribe((data) => {
    //   console.log(data,"222checking");
          
    // })
    
    // const userCategory = localStorage.getItem('category');
    // console.log(userCategory);
    // this.createmeetingform.get('district').value(this.userDistrict);
    // this.createmeetingform.get('constituency').value(this.userConstituency);
      // console.log(this.userDistrict,this.userConstituency,this.ApiService.user_details,"djnjdn");
    // Remove double quotation marks from userCategory
    // const cleanedUserCategory = userCategory.replace(/"/g, '');
    // console.log(cleanedUserCategory);
    // if (cleanedUserCategory === 'OB') {
    //   console.log('Inside if block');
    //   this.isButtonDisabled = true;
    // } else {
    //   console.log('Inside else block');
    //   this.isButtonDisabled = false;
    // }

    this.ApiService.getEnrolledCourses(this.stdID,this.permanent_token).subscribe(
      (response) => {
        if (response.status === 'success') {
          this.enrolledCourses = response.courses;
          console.log('Enrolled Courses:', this.enrolledCourses);
        } else {
          console.error('Error fetching enrolled courses:', response.message);
        }
      },
      (error) => {
        console.error('API error:', error);
      }
    );
  

    this.date = new Date();
    console.log('this.users.first_name: ', this.users.first_name);

      this.ApiService.courseAssignedToMentor(this.users.first_name).subscribe((data: any) => {
        console.log('this.users.first_name: ', this.users.first_name);
       console.log(data, "111sknsdnjs");
       this.mentor_data = data;  
     })
    
        this.ApiService.StudentCourseEntroll(this.userForm.id,this.userForm.district).subscribe((data) => {
       console.log(data,"222checking");
          this.customers = data;
           this.tableshow=true;
    })

    

    this.ApiService.getOBDetailsForDistrictOccurance().subscribe((data) => {
      this.ob_data = data;
      console.log(data,"333checking");

    })
   

// document.write(today);
    this.customers=[];
    this.showSpinner();
    // this.ApiService.getDistrictOccurance().subscribe((data:any) => {
      
    //   this.customers=data;
    //   this.tableshow=true;
    //   //console.log(this.customers.length);
    //   //console.log(obj.data.length);
    //   console.log(this.customers);
      
    // })
    
     this.ApiService.getCourses().subscribe((data: any) => {
       console.log(data, "444s,mfdnsd");
       this.courses = data;
     
      
      
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      })

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [2,'asc']
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  this.da_district=localStorage.getItem('user_district');
 

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('district').setValue(this.userDistrict);
    this.createmeetingform.get('constituency').setValue(this.userConstituency);
    this.createmeetingform.get('user_id').setValue(this.userId);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  customers:any=[];
  

  postdata(angForm1 : any) //angForm1
    {
    console.log(angForm1.value);

          this.ApiService.createDistrictOccurance(angForm1.value).pipe().subscribe(
            data => {
              console.log(data);
              console.log(data,"555checking");

              this.spinnerService.hide();
              setTimeout(() => {
                Swal.fire({
                  title: "Course District Occurrence has been created!",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor:'#015792',
                  iconColor: "#015792" // Set the icon color here
                }).then(() => {
                  window.location.reload();
                });
              }, 100);
            },
            
              
              error => {
                console.log(error);
              });
          }
    
 
    delete_CM(id : any){
      console.log(id)
      if(confirm("Are you sure want to cancel this District Occurance ?")) {
        console.log("Implement delete functionality here");
        
          this.ApiService.deleteDistrictOccurance(id)
          .pipe()
          .subscribe(
            data => {
              console.log(data,"666checking");

              Swal.fire({
                title: "Course District Occurrence has been deleted Successfully!",
                icon: "success",
                confirmButtonColor:'#015792',
                confirmButtonText: "Okay",
                iconColor: "#015792" // Set the icon color here
              }).then(() => {
                window.location.reload();
              });
            },
            

          error => {
              console.log(error);
          });

  }
}

    

  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
  Participants(a:any){
    this.participantsptions=a;
  }
  CM_course_name: any;
  CM_district: any;
  CM_constituency: any;
  CM_organizer: any;
  CM_startDate: any;
  CM_endDate: any;
  CM_startTime: any;
  CM_endTime: any;
  CM_volunteer1: any;
  CM_volunteer2: any;
  CM_location: any;
  CM_status: any;
  CM_comments: any;
  CM_mentor_name:any;
  CM_typeofcourse:any;
  CM_course_time:any;

  CM_course_id: any;

  editfield:boolean=false;
  async buttonviewmeeting(a:any,editbutton:any ){
    // this.feedbackStudent(a);  // Check and update feedbackIconDisable

    console.log(a,editbutton);
    this.CM_course_name=a.course_name;
    this.CM_mentor_name=a.mentor_name;
    this.CM_typeofcourse=a.typeofcourse;
    this.CM_course_time=a.course_time;

    console.log('this.CM_course_name: ', this.CM_course_name);
    this.CM_district=a.district;
    this.CM_constituency=a.constituency;
    this.CM_comments = a.comments;
    this.CM_endDate=a.end_date;
    console.log('course_end_date: ', a.end_date);
    this.CM_startDate = a.course_date;
    this.CM_location=a.location;
    console.log(' this.CM_startDate: ',  this.CM_startDate, this.CM_location);
    this.CM_organizer = a.organizer;
    this.CM_endTime=a.end_time;
    this.CM_volunteer1=a.volunteer1;
    this.CM_id=a.id;
    this.CM_course_id = a.course_id;
  this.CM_no_of_students=a.no_of_students;
  this.CM_students_attendance=a.students_attendance;
  this.CM_mentor=a.volunteer1;
  this.editmeetingform.get('course_name').setValue(a.course_name);
   this.editmeetingform.get('organizer').setValue(a.organizer);
   this.editmeetingform.get('location').setValue(a.location);
   this.editmeetingform.get('start_date').setValue(a.start_date);
   this.editmeetingform.get('end_date').setValue(a.end_date);
  
   a['student_id'] = this.users.id;

   await this.ApiService.studentFeedbackcheck(a).subscribe(
      (data: any) => {
        console.log(data);
        this.spinnerService.hide();
        if (data.hasOwnProperty('message')) {

           this.hidebutton=true;
            let b= data.existing_feedback
            console.log('b: ', b);
            this.hidebutton=true;       
            this.editmeetingform.get('facilities_in_venue').setValue(String(b.facilities_in_venue));
            this.editmeetingform.get('topic_clarity').setValue(String(b.topic_clarity));
            this.editmeetingform.get('overall_co_ordination').setValue(String(b.overall_co_ordination));
            this.editmeetingform.get('overall_rating_about_session').setValue(String(b.overall_rating_about_session));
            this.editmeetingform.get('overall_understanding').setValue( String(b.overall_understanding));
            this.editmeetingform.get('comments').setValue(b.comments);
          //  this.editmeetingform.get('').setValue(a.organizer);


            }
       else {
        this.hidebutton=false;

        }
      },
      (error: any) => {
        console.log(error);
        this.spinnerService.hide();
        // Handle error
      }
    );
          //this.editformInitialize(false);
      
   
    // this.editmeetingform.get('meeting_date').setValue(a.date);
    // this.editmeetingform.get('meeting_time').setValue(a.time);
          //this.editmeetingform.controls['meeting_date'].disable();
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_date);
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_time);

    }
    fn(){
      console.log('this.CM_endDate: ', this.CM_endDate);}
          editformInitialize(a){
            this.editmeetingform= this.fb.group({
             
           course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      start_date:['',Validators.required],
      end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: ['', Validators.required],
      user_id:[''],
      comments:[''],
      location:['',Validators.required],
              status: [''],
              topic_clarity: [''],
              facilities_in_venue: [''],
              overall_rating_about_session: [''],
              overall_understanding: [''],
              overall_co_ordination:[''],
              no_of_students:[''],
              students_attendance:['']
          });
          }
        
          updatedata(updateform, id) {
            this.spinner = true;
            
            let values = updateform.value;
            values['course_id'] = id;
            values['student_id'] = this.users.id;
            values['student_name'] = this.users.name;
          
            this.ApiService.createStudentFeedback(values).subscribe(
              (data:any) => {
                this.spinner = false; 
          
                if (data.error) {
                  // Handle the error if feedback already exists
                  Swal.fire({
                    title: "Feedback Already Submitted",
                    text: data.error,
                    icon: "warning",
                    confirmButtonText: "Okay",
                    confirmButtonColor: '#015792',
                    iconColor: "#ff8800"
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.reload();
                    }
                  });
                } else {
                  // Successful feedback submission
                  Swal.fire({
                    title: "Feedback Submitted",
                    text: "Thank you for your feedback!",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: '#015792',
                    iconColor: "#015792"
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.reload();
                    }
                  });
                }
              },
              error => {
                this.spinner = false;
                // Handle any other errors
                Swal.fire({
                  title: "Error",
                  text: "An error occurred while submitting feedback. Please try again later.",
                  icon: "error",
                  confirmButtonText: "Okay",
                  confirmButtonColor: '#015792',
                  iconColor: "#ff0000"
                });
              }
            );
          }
          

//reset form values in createform
  Formreset(){
    this.createmeetingform.reset();
    this.hidden=true;
    this.MeetingOptions='';
    //this.participantsptions='';
}
// feedbackStudent(customer:any){
//    if(customer.feedback_status=='yes'&& customer.has_feedback=='yes'){
//        return true;
//    }
//    else{
//     return false;

//    }
// }

feedbackStudent(customer: any): boolean {
  return customer.feedback_status === 'yes' && customer.has_feedback === 'yes';
}

}
